import messages from '../../../../messages';

const TimelineEditSchema = (props) => ({
  title: 'FCMH: Timeline',
  fieldsets: [
    {
      id: 'default',
      title: 'Allgemein',
      fields: ['headline', 'backgroundColor'],
    },
    {
      id: 'items',
      title: props.intl.formatMessage(messages.timelineElements),
      fields: ['items'],
    },
  ],
  properties: {
    headline: {
      title: props.intl.formatMessage(messages.headerTitle),
      type: 'string',
    },

    backgroundColor: {
      title: 'Hintergrundfarbe',
      description:
        'Bestimmt die Hintergrundfläche des gesamten Timeline-Blocks.',
      widget: 'fcmhColorSelect',
      default: 'white',
    },

    items: {
      title: props.intl.formatMessage(messages.timelineElements),
      widget: 'object_list',
      schema: {
        fieldsets: [
          {
            id: 'default',
            title: props.intl.formatMessage(messages.timelineElements),
            fields: [
              'position',
              'title',
              'description',
              'image',
              'copyrightText',
            ],
          },
        ],
        properties: {
          position: {
            title: props.intl.formatMessage(messages.timelineElementPosition),
            type: 'string',
            choices: [
              [
                'left',
                props.intl.formatMessage(messages.statisticsAlignmentLeft),
              ],
              [
                'right',
                props.intl.formatMessage(messages.statisticsAlignmentRight),
              ],
            ],
            default: 'right',
          },
          title: {
            title: props.intl.formatMessage(messages.timelineElementTitle),
            type: 'string',
          },
          description: {
            title: props.intl.formatMessage(
              messages.timelineElementDescription,
            ),
            widget: 'textarea',
          },
          image: {
            title: props.intl.formatMessage(messages.timelineElementImage),
            widget: 'object_browser',
            mode: 'image',
          },
          copyrightText: {
            title: 'Bildnachweis',
            description:
              'Wird als Bildnachweis am Bild angezeigt (© Icon unten rechts).',
            widget: 'textarea',
          },
        },
        required: ['title'],
      },
    },
  },
  required: [],
});

export default TimelineEditSchema;
